var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShoppingCart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.5416 18.7502C14.347 18.7502 14.9999 18.0972 14.9999 17.2918C14.9999 16.4864 14.347 15.8335 13.5416 15.8335C12.7362 15.8335 12.0833 16.4864 12.0833 17.2918C12.0833 18.0972 12.7362 18.7502 13.5416 18.7502Z",
    fill: "#CCCFD6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M6.87508 18.7502C7.6805 18.7502 8.33341 18.0972 8.33341 17.2918C8.33341 16.4864 7.6805 15.8335 6.87508 15.8335C6.06967 15.8335 5.41675 16.4864 5.41675 17.2918C5.41675 18.0972 6.06967 18.7502 6.87508 18.7502Z",
    fill: "#CCCFD6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.03341 3.28317L3.86675 5.32484C3.83341 5.7165 4.14175 6.0415 4.53342 6.0415H17.2917C17.6417 6.0415 17.9334 5.77483 17.9584 5.42483C18.0668 3.94983 16.9417 2.74984 15.4667 2.74984H5.24174C5.15841 2.38317 4.99174 2.03317 4.73341 1.7415C4.32508 1.29983 3.74175 1.0415 3.14175 1.0415H1.66675C1.32508 1.0415 1.04175 1.32484 1.04175 1.6665C1.04175 2.00817 1.32508 2.2915 1.66675 2.2915H3.11675C3.37509 2.2915 3.61675 2.39984 3.79175 2.58318C3.96675 2.77484 4.05008 3.02484 4.03341 3.28317Z",
    fill: "#CCCFD6"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.0916 7.2915H4.3083C3.9583 7.2915 3.67496 7.55817 3.64163 7.89983L3.34163 11.5248C3.22496 12.9415 4.34163 14.1665 5.76663 14.1665H15.0333C16.2833 14.1665 17.3833 13.1415 17.475 11.8915L17.75 7.99984C17.7833 7.61651 17.4833 7.2915 17.0916 7.2915Z",
    fill: "#838B9B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShoppingCart);
export default __webpack_public_path__ + "static/media/shopping-cart.ade6c31092ea778255b979a76b391a6b.svg";
export { ForwardRef as ReactComponent };